import Vapi from '@borisp/vuex-rest-api'
import { getOptimisticDelete, payloadToState } from 'utils/helpers'
import { VUE_APP_BASE_API_URL }  from '../../constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    imageSizes: [],
    imageSizesMetadata: {},
    imageSize: {}
  }
})
  .get({
    action: 'getImageSizes',
    property: 'imageSizes',
    queryParams: true,
    path: '/image-sizes/',
    onSuccess: payloadToState('imageSizes')
  })
  .post({
    action: 'createImageSize',
    property: 'imageSize',
    path: '/image-sizes/',
    onSuccess: payloadToState('imageSize')
  })
  .get({
    action: 'getImageSize',
    property: 'imageSize',
    path: ({ id }) => `/image-sizes/${id}`,
    onSuccess: payloadToState('imageSize')
  })
  .put({
    action: 'updateImageSize',
    property: 'imageSize',
    path: ({ id }) => `/image-sizes/${id}`,
    onSuccess: payloadToState('imageSize')
  })
  .delete({
    action: 'deleteImageSize',
    property: 'imageSize',
    path: ({ id }) => `/image-sizes/${id}`,
    beforeRequest: getOptimisticDelete('imageSizes'),
    onSuccess: payloadToState('imageSize')
  })
  .getStore()
